import { Filters as DetailedReportFilter } from './Filters';

export default DetailedReportFilter;
